module.exports = __webpack_public_path__ + "img/client_coq_frit.6a796d80.jpg";